import { z } from 'zod';

// POST /auth/request-code — start sign-in by emailing a 6-digit code.
// Copy reference: prototype/src/portal.jsx sign-in screen ("A six-digit code
// will be sent to this address."). Non-leaky: same shape returned whether or
// not the email is registered.
export const RequestCodeInputSchema = z.object({
  email: z.string().email().toLowerCase(),
});
export type RequestCodeInput = z.infer<typeof RequestCodeInputSchema>;

export const RequestCodeOutputSchema = z.object({
  ok: z.literal(true),
  // UI hint: "Sent to {email} · expires in 10:00"
  ttl_seconds: z.number().int().positive(),
});
export type RequestCodeOutput = z.infer<typeof RequestCodeOutputSchema>;

// POST /auth/verify-code
export const VerifyCodeInputSchema = z.object({
  email: z.string().email().toLowerCase(),
  code: z.string().regex(/^\d{6}$/, 'Code must be 6 digits'),
});
export type VerifyCodeInput = z.infer<typeof VerifyCodeInputSchema>;

// 401 reasons surfaced to the UI so we can show specific copy.
export const AuthFailureReasonSchema = z.enum([
  'invalid_code',
  'expired_code',
  'too_many_attempts',
  'unknown_email',
  'user_suspended',
]);
export type AuthFailureReason = z.infer<typeof AuthFailureReasonSchema>;
